import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { jsx } from '@theme-ui/core';
import { css, get } from '@theme-ui/css';
import { useMemo } from 'react';
import { useMDXComponents, MDXProvider as MDXProvider$1 } from '@mdx-js/react';
/** @jsx jsx */
// mdx components

var tags = ['p', 'b', 'i', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'pre', 'code', 'ol', 'ul', 'li', 'blockquote', 'hr', 'em', 'table', 'tr', 'th', 'td', 'em', 'strong', 'del', // mdx
'inlineCode', 'thematicBreak', // other
'div', // theme-ui
'root'];
var aliases = {
  inlineCode: 'code',
  thematicBreak: 'hr',
  root: 'div'
};

var isAlias = function isAlias(x) {
  return x in aliases;
};

var alias = function alias(n) {
  return isAlias(n) ? aliases[n] : n;
};

var themed = function themed(key) {
  return function (theme) {
    return css(get(theme, "styles.".concat(key)))(theme);
  };
}; // opt out of typechecking whenever `as` prop is used


var createThemedComponent = function createThemedComponent(name, variant) {
  var variantStyles = themed(variant);

  var component = function component(props) {
    var extraStyles = {};

    if (name === 'th' || name === 'td') {
      var align = props.align;
      if (align !== 'char') extraStyles.textAlign = align;
    }

    var css = props['css'];
    return jsx(name, _objectSpread(_objectSpread({}, props), {}, {
      css: [props.css, variantStyles, extraStyles].filter(Boolean)
    }));
  };

  component.displayName = "Themed(".concat(name, ")");
  return component;
};

var _Themed = createThemedComponent('div', 'div');

var components = {};
var Themed = _Themed;
tags.forEach(function (tag) {
  var component = createThemedComponent(alias(tag), tag);
  components[tag] = component;
  Themed[tag] = component;
});

var createComponents = function createComponents(comps) {
  var componentKeys = Object.keys(comps);

  var next = _objectSpread({}, components); // We enrich user's components with the styles from theme.styles.
  // Example: `components.p` will get the styles from `theme.styles.p` as className.
  // todo: test this behaviour


  componentKeys.forEach(function (key) {
    var componentAtKey = comps[key];

    if (componentAtKey) {
      var component = function component(props) {
        return jsx(componentAtKey, _objectSpread(_objectSpread({}, props), {}, {
          css: themed(key)
        }));
      };

      component.displayName = "MdxComponents('" + key + "')";
      next[key] = component;
    }
  });
  return next;
};

var MDXProvider = function MDXProvider(_ref) {
  var components = _ref.components,
      children = _ref.children;
  var outer = useMDXComponents();
  var themedComponents = useMemo(function () {
    return createComponents(_objectSpread(_objectSpread({}, outer), components));
  }, [components, outer]);
  return jsx(MDXProvider$1, {
    components: themedComponents,
    children: children
  });
};

export { MDXProvider, Themed, components, themed };